import React from 'react'

import { Helmet } from 'react-helmet'

import AppComponent from '../components/component'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Prasanga Resume</title>
        <meta property="og:title" content="Prasanga Resume" />
        <link
          rel="canonical"
          href="https://prasanga101.github.io/protfolio-prasanga/"
        />
        <meta
          property="og:url"
          content="https://prasanga101.github.io/protfolio-prasanga/"
        />
      </Helmet>
      <AppComponent />
    </div>
  )
}

export default Home
